// 실시간 데이터 수정
export const GAME_CONFIG_INFO_LIST_REQUEST = 'GAME_CONFIG_INFO_LIST_REQUEST';

export const CREATE_GAME_CONFIG = 'CREATE_GAME_CONFIG';

export const REMOVE_GAME_CONFIG = 'REMOVE_GAME_CONFIG';

export const UPDATE_GAME_CONFIG = 'UPDATE_GAME_CONFIG';
